<template>
  <fullscreen
    background="#F3F5F7"
    class="fullscreen-tabs"
    ref="fullscreen"
    @change="fullScreenChange"
  >
    <ModalTableDescription
      v-model="descriptionModal.show"
      :description="description"
    />
    <div class="fullscreen-tabs-controls">
      <div class="fullscreen-tabs-controls-left">
        <slot name="tabsControls"></slot>
      </div>
      <div class="fullscreen-tabs-controls-right">
        <slot name="tabsControlsRight"></slot>
        <div class="table-controls-right__item">
          <a
            class="link"
            v-if="description.length"
            @click.prevent="openModalTableDescription"
          >
            Description
          </a>
        </div>
        <b-button
          v-if="!hideFullscreen"
          class="button btn-icon"
          variant="outline-info"
          @click="toggleFullscreen"
        >
            <span class="material-icons">
              fullscreen
            </span>
        </b-button>
      </div>
    </div>
    <div class="tabs-content-wrapper">
      <slot name="tabsContent"></slot>
    </div>
  </fullscreen>
</template>

<script>
import ModalTableDescription from '@components/modals/ModalTableDescription'

export default {
  components: {
    ModalTableDescription
  },
  props: {
    description: {
      type: Array,
      default: () => []
    },
    hideFullscreen: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      descriptionModal: {
        show: false
      }
    }
  },
  methods: {
    openModalTableDescription () {
      this.descriptionModal.show = true
    },
    toggleFullscreen () {
      this.$refs['fullscreen'].toggle()
    },
    fullScreenChange (fullscreen) {
      this.fullscreen = fullscreen
    }
  }
}
</script>

<style lang="scss" scoped>
.fullscreen-tabs-controls {
  padding: 15px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  border-bottom: 1px solid #F3F5F7;
}

.fullscreen-tabs-controls,
.fullscreen-tabs-controls-left,
.fullscreen-tabs-controls-right {
  display: flex;
  justify-content: space-between;
  background-color: #fff;
}

.fullscreen-tabs {
  .table-container, .table-controls {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
}

.fullscreen-tabs.fullscreen {
  padding: 10px;
}

.tabs-content-wrapper {
  overflow-y: auto;
}
</style>
